import Card from '../Card';
import cardExample from '../../../../../../assets/profile/card-example.png';

import api from '../../../../../../services/api';

import { Container } from './styles';

const ListCards = ({ cards, setCardAsDefault }) => {
  const renderCards = () => {
    return cards.map((card) => {
      const activeClass = card.is_active ? 'active' : '';
      return (
        <div
          className={`list-cards ${activeClass}`}
          onClick={() => setCardAsDefault(card.id)}
        >
          <Card creditCard={card} />
        </div>
      );
    });
  };

  return (
    <Container style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', flexWrap: 'wrap' }} className="list-cards">
      {cards.length === 0 ? (
        <img style={{ marginTop: '1.5rem' }} src={cardExample} alt="Exemplo de cartão de crédito" />
      ) : (
        <>{renderCards()}</>
      )}
    </Container>
  );
};

export default ListCards;
